import * as actionTypes from './actionTypes';

const filterReducer =
    (source) =>
    (state = [], action) => {
        if (action.source !== source) {
            return state;
        }

        return itemReducer(state, action);
    };

export const itemReducer = (state, action) => {
    switch (action.type) {
        case actionTypes.ITEM_ADD:
            return {
                ...state,
                [action.item.id]: action.item,
            };
        case actionTypes.ITEM_MARK_READ:
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    isRead: true,
                    unread_count: 0,
                },
            };
        case actionTypes.ITEM_MARK_UNREAD:
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    isRead: false,
                },
            };
        default:
            return state;
    }
};

export default filterReducer;
